import React from "react";
import Body from "./body";

function Home() {
  return (
    <div>
      <Body />
    </div>
  );
}

export default Home;
